
import { Mixins, Component, Prop, Ref } from "vue-property-decorator";
import { SmartText, CTAButton, PostGrid } from "_components";
import { getApi, onResize } from "_mixins";
import { Locale } from "_core";
import { gridCardFetchAmount } from "_utils";
import { HomePageLatestSectionType } from "../../types";
import { ThemeLink, THEME_LINKS, THEME_LINK_TYPE } from "@app/types";

@Component({
  name: "HomeLatest",
  components: { SmartText, CTAButton, PostGrid },
})
export default class HomeLatest extends Mixins(getApi, onResize) {
  @Prop() sectionData: HomePageLatestSectionType;
  @Ref() postGridRef: PostGrid;
  rootClass = "c-home-latest";

  observer: MutationObserver = null;

  get title() {
    return this.sectionData.title;
  }

  get enableButton() {
    return this.sectionData.enable_all_button;
  }

  get amountToLoadAtATime() {
    return gridCardFetchAmount(window.innerWidth);
  }

  get allPostsLink(): ThemeLink {
    return {
      label: this.sectionData.show_all_button_label,
      type: THEME_LINK_TYPE.THEME_LINK,
      theme_link: THEME_LINKS.ALL_ARTICLES,
    };
  }

  beforeMount() {
    this.query = `__HOMEPAGE_POSTS__?lang=${Locale.currentLocale}&amount=${this.amountToLoadAtATime}`;
  }

  mounted() {
    const config = { attributes: true, childList: true, subtree: true };
    this.observer = new MutationObserver(this.onMove);
    this.observer.observe(this.postGridRef.$el, config);
  }

  beforeDestroy() {
    this.observer.disconnect();
  }

  onMove() {
    this.postGridRef.init();
  }

  onResize() {
    const updatedApiRoute = `__HOMEPAGE_POSTS__?lang=${Locale.currentLocale}&amount=${this.amountToLoadAtATime}`;
    if (this.query !== updatedApiRoute) this.query = updatedApiRoute;
  }
}
